import { useEffect, useState } from 'react';
import { default as axios } from '../axiosConfig';
import { API_ApproveUser, API_BanUser, API_GetPendingUsers, API_RejectUser } from '../Assets/ApiUrlContainer';

const AdminUserManagement = () => {
	const [pendingUsers, setPendingUsers] = useState([]);
	const [loading, setLoading] = useState(false);
	const [selectedRoles, setSelectedRoles] = useState({});
	const [searchTerm, setSearchTerm] = useState(''); // Search term state

	useEffect(() => {
		fetchPendingUsers();
	}, []);

	const fetchPendingUsers = async () => {
		try {
			console.log('Fetching Pending Users from:', API_GetPendingUsers);

			const response = await axios.get(API_GetPendingUsers, {
				withCredentials: true,
				headers: { 'Content-Type': 'application/json' },
			});

			console.log('Fetched Pending Users:', response.data);
			setPendingUsers(response.data);
		} catch (error) {
			console.error('Error fetching pending users:', error);
		}
	};

	const handleAction = async (email, action) => {
		let endpoint = '';
		let payload = { email };

		if (action === 'approve') {
			endpoint = API_ApproveUser;
			payload.role = selectedRoles[email] || 'employee'; // Default role if not selected
		}

		if (action === 'reject') endpoint = API_RejectUser;
		if (action === 'ban') endpoint = API_BanUser;
		console.log(`Performing ${action} on ${email}. Endpoint: ${endpoint}`);

		setLoading(true);
		try {
			const response = await axios.post(endpoint, payload, {
				withCredentials: true,
				headers: { 'Content-Type': 'application/json' },
			});

			console.log(`${action} Response:`, response.data);

			if (action === 'ban') {
				setPendingUsers(pendingUsers.filter((user) => user.Email !== email));
			} else {
				fetchPendingUsers();
			}
		} catch (error) {
			console.error(`Error performing ${action} action:`, error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
			<h2 style={{ textAlign: 'center' }}>Pending User Management</h2>

			{/* Search Bar */}
			<input
				type='text'
				placeholder='Search by name or email...'
				value={searchTerm}
				onChange={(e) => setSearchTerm(e.target.value)}
				style={{
					display: 'block',
					width: '100%',
					padding: '10px',
					marginBottom: '15px',
					borderRadius: '5px',
					border: '1px solid #ddd',
				}}
			/>

			{/* Refresh Button */}
			<button
				onClick={fetchPendingUsers}
				style={{
					marginBottom: '15px',
					padding: '10px 16px',
					cursor: 'pointer',
					backgroundColor: '#3498db',
					color: 'white',
					border: 'none',
					borderRadius: '5px',
					fontSize: '14px',
				}}
			>
				🔄 Refresh List
			</button>

			<table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
				<thead>
					<tr style={{ backgroundColor: '#f2f2f2', textAlign: 'left' }}>
						<th style={{ padding: '10px' }}>First Name</th>
						<th style={{ padding: '10px' }}>Last Name</th>
						<th style={{ padding: '10px' }}>Email</th>
						<th style={{ padding: '10px' }}>Role</th>
						<th style={{ padding: '10px' }}>Actions</th>
					</tr>
				</thead>
				<tbody>
					{pendingUsers
						.filter(
							(user) =>
								user.FirstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
								user.LastName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
								user.Email?.toLowerCase().includes(searchTerm.toLowerCase())
						)
						.map((user) => (
							<tr key={user.Email} style={{ borderBottom: '1px solid #ddd' }}>
								<td style={{ padding: '10px' }}>{user.FirstName}</td>
								<td style={{ padding: '10px' }}>{user.LastName}</td>
								<td style={{ padding: '10px' }}>{user.Email}</td>

								{/* Role Selection Dropdown */}
								<td style={{ padding: '10px' }}>
									<select
										value={selectedRoles[user.Email] || ''}
										onChange={(e) =>
											setSelectedRoles({ ...selectedRoles, [user.Email]: e.target.value })
										}
										style={{
											padding: '5px',
											borderRadius: '5px',
											border: '1px solid #ccc',
										}}
									>
										<option value=''>Select Role</option>
										<option value='admin'>Admin</option>
										<option value='employee'>Employee</option>
										<option value='TGS-Approver'>TGS-Approver</option>
										<option value='TGS-Admin'>TGS-Admin</option>
										<option value='IT'>IT</option>
										<option value='Candidate'>Candidate</option>
										<option value='Financial Controller'>Financial Controller</option>
										<option value='Manager'>Manager</option>
										<option value='Hiring Manager'>Hiring Manager</option>
										<option value='ProxyHiringManager'>Proxy Hiring Manager</option>
									</select>
								</td>

								<td style={{ padding: '10px' }}>
									<button
										disabled={loading}
										onClick={() => handleAction(user.Email, 'approve')}
										style={{
											marginRight: '5px',
											padding: '8px',
											backgroundColor: 'green',
											color: 'white',
											border: 'none',
											borderRadius: '5px',
											cursor: 'pointer',
										}}
									>
										Approve
									</button>

									<button
										disabled={loading}
										onClick={() => handleAction(user.Email, 'reject')}
										style={{
											marginRight: '5px',
											padding: '8px',
											backgroundColor: 'red',
											color: 'white',
											border: 'none',
											borderRadius: '5px',
											cursor: 'pointer',
										}}
									>
										Reject
									</button>

									<button
										disabled={loading}
										onClick={() => handleAction(user.Email, 'ban')}
										style={{
											padding: '8px',
											backgroundColor: 'orange',
											color: 'white',
											border: 'none',
											borderRadius: '5px',
											cursor: 'pointer',
										}}
									>
										Block
									</button>
								</td>
							</tr>
						))}
				</tbody>
			</table>
		</div>
	);
};

export default AdminUserManagement;
